module.exports = __webpack_public_path__ + "img/index11.d06d696b.jpg";